import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { DDPNotitie } from '../types/ddpTypes';

const useGetNotities = () => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<DDPNotitie[]> = async () => {
    const response = await fetchWithAuth(`/ddp/notities`);
    throwIfResponseNotOk(response, `Ophalen van notities is mislukt (${response.status}).`);
    const notities: DDPNotitie[] = await response.json();
    return notities;
  };

  return useQuery({
    queryKey: ['ddpNotities'],
    queryFn: fetcher,
    refetchInterval: 10_000,
    meta: managedPageQueryMeta,
  });
};
export default useGetNotities;
